/**
 * Controles de paginación del historial de talonarios (presentacional).
 *
 * Refleja la paginación de `GET /api/v1/talonarios/history` (`page`/`pages`/
 * `total`). Recibe el estado y un callback `onPageChange`; no decide datos. Los
 * botones se inhabilitan en los extremos. Mismo patrón que la paginación de
 * Órdenes, en el dominio de talonarios (sin acoplarse a otro feature).
 */
import { Button } from "@/components/ui";

interface TalonarioPaginationProps {
  page: number;
  pages: number;
  total: number;
  onPageChange: (page: number) => void;
  /** Deshabilita los controles mientras se recarga (evita doble clic). */
  disabled?: boolean;
}

export function TalonarioPagination({
  page,
  pages,
  total,
  onPageChange,
  disabled = false,
}: TalonarioPaginationProps) {
  const safePages = Math.max(pages, 1);
  const canPrev = page > 1;
  const canNext = page < safePages;

  return (
    <nav
      className="flex items-center justify-between gap-4 px-1 py-3"
      aria-label="Paginación del historial"
    >
      <p className="text-sm text-slate-500">
        Página {page} de {safePages} · {total} registro{total === 1 ? "" : "s"}
      </p>
      <div className="flex gap-2">
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => onPageChange(page - 1)}
          disabled={disabled || !canPrev}
        >
          Anterior
        </Button>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={disabled || !canNext}
        >
          Siguiente
        </Button>
      </div>
    </nav>
  );
}
